import StarBorderIcon from '@mui/icons-material/StarBorder';
import { Card, CardActions, CardContent, Chip, Stack, Typography } from '@mui/material';
import { InternalLink } from 'components/shared/InternalLink';
import { IAnalysis } from 'data/types';
import { getAnalysisRoute } from 'routes';
import { Byline } from './Byline';
import { SharesDisplay } from './SharesDisplay';
import { VerdictDisplay } from './VerdictDisplay';

interface IProps {
  storyId: string;
  slug: string;
  analysis: IAnalysis;
  isTopRated?: boolean;
}

export function AnalysisCard(props: IProps) {
  const { storyId, slug, analysis, isTopRated } = props;
  const { id: analysisId, author, verdict, shareCount, title, publishedAt } = analysis;

  return (
    <Card>
      <CardContent>
        <Stack
          direction={{ xs: 'row', sm: 'column', md: 'row' }}
          alignItems={{ xs: 'center', sm: 'start', md: 'center' }}
          spacing={1}
          sx={{ mb: 1 }}
        >
          <VerdictDisplay value={verdict} isActive />
          <SharesDisplay shareCount={shareCount} />
          {isTopRated && <Chip icon={<StarBorderIcon />} label="Top rated" />}
        </Stack>

        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>

        <Byline publishedAt={publishedAt} author={author} />
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <InternalLink to={getAnalysisRoute(storyId, slug, analysisId)}>Read more</InternalLink>
      </CardActions>
    </Card>
  );
}
